/* eslint-disable */
// TODO: Get descriptions directly from ANS Schema
import { get } from 'lodash'
import intl from 'react-intl-universal'

import basicTemplateConfig from './basicMetaTemplateText.js'
import metaConfig from '../settings/meta.js'
import handleRequired from '../../util/handleRequired'
import { setFieldConfigs } from '~/redux/editor-fields'

export default ['picklistService', '$rootScope', '$ngRedux', metaTemplates]

// this needs to be dictionary, originally a collection
export const picklistConfig = {
  ...[...metaConfig].reduce((acc, obj) => {
    acc[obj.key] = obj
    return acc
  }, {}),
  ...basicTemplateConfig,
}

const isRequired = `
<span class="color-danger font-weight-bold" ng-if="isRequired === true">
 ✱
</span>
`

const isReadOnly = (item) =>
  `${item.isReadOnly ? `disabled readonly="${item.isReadOnly}"` : ''}`

export function metaTemplates(picklistService, $rootScope, $ngRedux) {
  let baseMetaTemplates = {}
  this.baseMetaTemplates = baseMetaTemplates // haxor-y !!!
  // Get org (local dev does not have it set)
  const partnerOrg =
    window.localStorage['arc.organization'] ||
    (window.location.host === 'localhost' ? 'staging' : '')

  //render the character count label for working headline
  const renderCharacterCount = (item, key, path, settings) => {
    const { maxChars, maxCharsEnabled } = settings
    // the length of the working headline characters
    const workingHeadlineLength = `{{storyObj.${path}.length}}`
    // to display the max characters (e.g. 9 / 10) or none if disabled
    const maxCharCount = maxCharsEnabled && maxChars > 0 ? ` / ${maxChars}` : ''
    // intl label for the character count
    const characterCounter = intl.get('HeadlineForm.form.numOfCharacters', {
      numCharacters: `${workingHeadlineLength}${maxCharCount}`,
    })

    if (item.showCharCount) {
      return `
        <label for="${key}-length">
          <span data-testid="working-headline-length">${characterCounter}</span>
        </label>
      `
    }

    return ''
  }

  const renderPicklists = (picklistOptions) => {
    // ******************************* //
    // Meta elements that are simple
    // no extra html markup required have a simple object that generates it for us
    // We just add to the array in basicMetaTemplateText.json with the following settings
    /*
        "ANS_PROPERTY"
          "type": Values are "String", "DateTime", or "Boolean" (true or false)
          "label": The HTML label to be displayed
          "path": [optional] the model path to update. If not incuded, uses ANS_PROPERTY as the path.
          TODO: put type Textarea for type
          "isTextArea": [default false] Set to true if you want a textarea instead of textbox,
          "isReadOnly": Set to true if user can not edit value
          "picklist": If option can have a picklist set to true
          "default": (currently not used)
          "smartQuotes": Enable smart quotes as the user types
          "tab": Where we think this data should libe "meta" or "planning"
          "description": The plain text description of what the field is in ANS
          "roleRestriction": If the ANS property has roles that can disable the ability to edit, list the roles here with what they do.
        },
      */

    // ******************************* //
    // Meta elements that require Special HTML Markup
    // Add an object to baseMetaTemplates with the templates and functions needed.
    /*
      baseMetaTemplates.[THE ANS PROPERTY NAME] = {
          template: The HTML Template. ng-model is vm.storyObj.Your.Path.To.Whatver,
          "label": The HTML label to be displayed
          properties: Not being used, used to be used to do type conversions of data
          picklist: If option can have a picklist set to true
          default: (currently not used)
          tab: Where we think this data should libe "meta" or "planning"
          description: The plain text description of what the field is in ANS
      };
      */

    Object.keys(basicTemplateConfig).forEach((key) => {
      let item = basicTemplateConfig[key]
      let prop = {}
      let path = item.path || key
      let input
      let smartQuotes = item.smartQuotes ? 'smart-quote-handler' : ''
      var renderType = null
      prop[key] = item

      const picklistType = (picklistConfig[key] || {}).picklist

      /* Not the cleanest approach, but I'd rather avoid refactoring the following code until
       *  I understand more of the system.
       */
      if (picklistOptions !== null) {
        if (picklistOptions['picklists']) {
          if (
            Object.prototype.hasOwnProperty.call(
              picklistOptions['picklists'],
              key
            )
          ) {
            let picklist = picklistOptions['picklists'][key]
            if (Object.prototype.hasOwnProperty.call(picklist, 'renderType')) {
              renderType = picklist['renderType']
            }
          }
        }
      }
      if (renderType == null) {
        renderType = picklistType
      }
      const basicInput = (settings = {}) => {
        return `
            <input
              data-testid="editor-${item.label
                .split(' ')
                .join('-')
                .toLowerCase()}-input"
              ng-class="{'required': isRequiredNotify}"
              ng-if="!picklists.${key} || picklists.${key}.picklist.length < 1"
              type="text"
              ${smartQuotes}
              ng-attr-="{{item.label}}"
              class="form-control"
              id="${key}"
              data-testid="${key}"
              ng-change="change()"
              ng-blur="blur($event)"
              data-meta-type="basic input"
              data-key="${key}"
              placeholder="${item.label}"
              ng-model="storyObj.${path}"
              ${
                settings.maxCharsEnabled
                  ? `maxlength="${settings.maxChars}"`
                  : ''
              }
              ${isReadOnly(item)}>
            `
      }
      // TODO: use switch case vs if
      if (item.isTextOnly && item.type === 'DateTime') {
        input = (settings = {}) => `
              <input
                ng-class="{'required': isRequiredNotify}"
                type="text"
                class="form-control"
                id="${key}"
                data-meta-type="date time"
                data-key="${key}"
                moment-date-formatter="LLL"
                ng-model="storyObj.${path}"
                ${isReadOnly(item)} />
            `
      } else if (item.isTextArea) {
        input = (settings = {}) => `
                <textarea
                  data-testid="editor-${item.label
                    .split(' ')
                    .join('-')
                    .toLowerCase()}-textarea"
                  ng-class="{'required': isRequiredNotify}"
                  class="form-control"
                  ${smartQuotes}
                  data-key="${key}"
                  id=""
                  ${item.rows && 'rows="' + item.rows + '"'}
                  placeholder="${item.label}"
                  ng-change="change()"
                  ng-model="storyObj.${path}"
                  ${
                    settings.maxCharsEnabled
                      ? `maxlength="${settings.maxChars}"`
                      : ''
                  }
                  ${isReadOnly(item)}>
              </textarea>
            `
      } else if (item.type === 'Boolean') {
        input = (settings = {}) => `
              <div class="form-group meta-boolean">
                <div class="form-check form-check-inline">
                  <label class="form-check-label">
                    <input
                      type="radio"
                      class="form-check-input"
                      ng-class="{'required': isRequiredNotify}"
                      ng-change="change()"
                      ng-model="storyObj.${path}"
                      ng-value="true">
                      Yes
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <label class="form-check-label">
                    <input
                      type="radio"
                      class="form-check-input"
                      ng-class="{'required': isRequiredNotify}"
                      ng-change="change()"
                      ng-model="storyObj.${path}"
                      ng-value="false">
                      No
                  </label>
                </div>
              </div>`
      } else if (renderType === 'single') {
        input = (settings = {}) => `
              <div data-is-picklist data-key="${key}" data-path="${path}">
                <select
                  ng-class="{'required': isRequiredNotify}"
                  data-basic="false"
                  data-picklist="single"
                  ng-change="change(true)"
                  ng-if="picklists.${key} && picklists.${key}.picklist.length > 0"
                  ${
                    settings.maxCharsEnabled
                      ? `maxlength="${settings.maxChars}"`
                      : ''
                  }
                  ng-options="item.id as item.text for item in picklists.${key}.picklist | picklist"
                  ng-model="storyObj.${path}">
                </select>
                ${basicInput(settings)}
              </div>
            `
      } else if (renderType === 'multiple') {
        input = (settings = {}) => `
              <div data-key="${key}" class="input-group" ng-if="picklists.${key} && picklists.${key}.picklist.length > 0">
                <input
                  data-picklist="multiple"
                  ng-repeat="item in picklists.${key}.picklist | picklist"
                  ng-model="storyObj.${path}"
                  type="checkbox" />
              </div>
              ${basicInput(settings)}
            `
      } else if (renderType === 'freeText') {
        input = (settings = {}) => `
              <div
                ng-init="key = '${key}'; path = '${path}'"
                ng-model="storyObj.${path}">
              <div class="input-group"
                ng-init="toggleFreeText = false"
                ng-model="toggleFreeText">
                <div
                  class="input-group-btn"
                  ng-class="{'disabled': true}"
                  ng-if="picklists.${key} && picklists.${key}.picklist.length > 0">
                  <button type="button"
                    class="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                  <span>${intl.get(
                    'MetaTemplates.freeText.template.buttonText'
                  )}</span>
                  </button>
                  <div class="dropdown-menu" tabindex="-1">
                    <a
                      class="dropdown-item"
                      ng-class="{'required': isRequiredNotify}"
                      ng-repeat="item in picklists.${key}.picklist"
                      data-picklist="single"
                      data-basic="false"
                      ng-click="handleSelection(storyObj, '${path}', item, '${key}')">
                    <span ng-bind="item.text"></span>
                    </a>
                  </div>
                </div>
                <input
                  ng-model="storyObj.${path}"
                  model-as-picklist-human="${path}:${key}"
                  type="text"
                  class="form-control free-text-input"
                  placeholder="${intl.get(
                    'MetaTemplates.freeText.template.inputPlaceholder'
                  )}"
                  ng-blur="blur($event)"
                  area-label="${path} text"/>
              </div>
            `
      } else {
        input = basicInput
      }

      baseMetaTemplates[key] = item
      baseMetaTemplates[key].template = (settings = {}) => `
          <div data-meta-template class="form-group" data-key="${key}" data-path="${path}">
            <div class="row">
              <div class="col-md-10">
                <label for="${key}" class="col-md-10">
                  ${item ? item.labelSpecifyingLegacy || item.label : ''}
                  ${isRequired}
                </label>
              </div>
              <div class="col-md-2 text-right">
                ${renderCharacterCount(item, key, path, settings)}
              </div>
            </div>
              ${input(settings)}
          </div>
      `

      baseMetaTemplates[key].isValid = (storyObj) => {
        // Break up paths by periods
        const parts = path.split('.')
        const propKey = parts.pop()
        const obj = parts.reduce((o, k) => (o ? o[k] : undefined), storyObj)

        if (obj !== undefined && obj[propKey] !== undefined) {
          return !!obj[propKey].length
        }

        return false
      }
    })

    baseMetaTemplates.unknown = (type) => ({
      template: `
          <div>
            <label><strong>${intl.get(
              'MetaTemplates.unknown.template.label'
            )}</strong></label>
            <pre>${
              type || intl.get('MetaTemplates.unknown.template.unknown')
            } {{meta}}</pre>
          </div>
        `,
      isValid: (storyObj) => {
        return true
      },
    })

    baseMetaTemplates.geo = {
      label: intl.get('MetaTemplates.geo.label'),
      template: `<div class="form-group">
              <h5>${intl.get('MetaTemplates.geo.template.geoTitle')}</h5>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="">${intl.get(
                    'MetaTemplates.geo.template.latitudeLabel'
                  )} ${isRequired}</label>
                  <input
                    type="number"
                    class="form-control"
                    id=""
                    ng-class="{'required': isRequiredNotify}"
                    placeholder="${intl.get(
                      'MetaTemplates.geo.template.latitudeLabel'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj['geo'].latitude">
                </div>
                <div class="form-group col-md-6">
                  <label for="">${intl.get(
                    'MetaTemplates.geo.template.longitudeLabel'
                  )}</label>
                  <input
                    type="number"
                    class="form-control"
                    id=""
                    ng-class="{'required': isRequiredNotify}"
                    placeholder="${intl.get(
                      'MetaTemplates.geo.template.longitudePlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj['geo'].longitude">
                </div>
              </div>
            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.geo.description'),
      isValid: (storyObj) => {
        // EL-59: Given that the lat/long field is required for save,
        // then a user can enter lat but not long in order to meet the save requirement.
        const res =
          storyObj.geo &&
          ((storyObj.geo.latitude &&
            typeof storyObj.geo.latitude === 'number') ||
            (storyObj.geo.longitude &&
              typeof storyObj.geo.longitude === 'number'))
        return res
      },
      beforeOnSave: (storyObj) => {
        if (storyObj.geo) {
          if (
            storyObj.geo.latitude !== undefined &&
            (storyObj.geo.latitude === null ||
              !storyObj.geo.latitude.toString().length)
          ) {
            delete storyObj.geo.latitude
          }
          if (
            storyObj.geo.longitude !== undefined &&
            (storyObj.geo.longitude === null ||
              !storyObj.geo.longitude.toString().length)
          ) {
            delete storyObj.geo.longitude
          }
          if (!Object.keys(storyObj.geo).length) {
            delete storyObj.geo
          }
        }
      },
    }

    baseMetaTemplates.location = {
      label: intl.get('MetaTemplates.location.label'),
      template: `<div class="form-group">
              <label>${intl.get(
                'MetaTemplates.location.template.locationLabel'
              )} ${isRequired}</label>
              <input
                ng-class="{'required': isRequiredNotify}"
                type="text"
                ng-change="change()"
                class="form-control"
                placeholder="${intl.get(
                  'MetaTemplates.location.template.locationPlaceholder'
                )}"
                ng-model="storyObj.location">
            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.location.description'),
      isValid: (storyObj) => {
        return storyObj.location && storyObj.location.length
      },
    }

    baseMetaTemplates.address = {
      label: intl.get('MetaTemplates.address.label'),
      template: `<div class="form-group">
              <h5>${intl.get(
                'MetaTemplates.address.template.addressLabel'
              )}</h5>
              <div class="row">
                <div class="form-group col-md-12">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.streetAddressLabel'
                  )} ${isRequired}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.streetAddressPlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.street_address">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.extendedAddressPlaceholder'
                  )}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.extendedAddressPlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.extended_address">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.localityLabel'
                  )}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.localityPlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.locality">
                </div>
                <div class="form-group col-md-4">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.zipcodeLabel'
                  )}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.zipcodePlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.postal_code">
                </div>
                <div class="form-group col-md-4">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.countryLabel'
                  )}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.countryPlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.country_name">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.regionLabel'
                  )}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.regionPlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.region">
                </div>
                <div class="form-group col-md-4">
                  <label for="">${intl.get(
                    'MetaTemplates.address.template.poboxLabel'
                  )}</label>
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="${intl.get(
                      'MetaTemplates.address.template.poboxPlaceholder'
                    )}"
                    ng-change="change()"
                    ng-model="storyObj.address.post_office_box">
                </div>
              </div>

            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.address.description'),
      isValid: (storyObj = {}) => {
        // here be dragons
        const addr = {
          street_address: '',
          extended_address: '',
          locality: '',
          post_office_box: '',
          country_name: '',
          postal_code: '',
          region: '',
          ...(storyObj.address || {}),
        }
        const len = Object.keys(addr).reduce((str, k) => {
          return str + addr[k].length
        }, 0)
        return len > 0
      },
    }

    baseMetaTemplates.description = {
      label: intl.get('MetaTemplates.description.label'),
      template: (props) => `<div class="form-group">
              <label for="">${intl.get(
                'MetaTemplates.description.template.descriptionLabel'
              )} ${isRequired}</label>
              <textarea
                ng-class="{'required': isRequiredNotify}"
                maxlength="${props.maxCharsEnabled ? props.maxChars : false}"
                class="form-control"
                data-testid="description-textarea"
                id=""
                rows="6"
                placeholder="${intl.get(
                  'MetaTemplates.description.template.descriptionPlaceholder'
                )}"
                ng-change="storyObj.description.basic = (storyObj.description.basic | strSafe); change()"
                ng-model="storyObj.description.basic">
              </textarea>
           </div>`,
      properties: {},
      picklist: false,
      default: true,
      maxLength: true,
      tab: 'meta',
      type: 'text',
      description: '',
      isValid: (storyObj) => {
        return (
          storyObj.description &&
          storyObj.description.basic &&
          storyObj.description.basic.length
        )
      },
    }

    baseMetaTemplates.seo_keywords = {
      label: intl.get('MetaTemplates.seo.label'),
      template: `<div class="form-group">
              <label for="tax_seo">${intl.get(
                'MetaTemplates.seo.template.seoLabel'
              )} ${isRequired}</label>
              <tags-input
                data-testid="editor-seo-input"
                min-length="1"
                ng-class="{'required': isRequiredNotify}"
                ng-model="seo_kws"
                ng-init="seo_kws=(storyObj.taxonomy.seo_keywords || []).slice()"
                ng-change="storyObj.taxonomy.seo_keywords = tagsToArray(seo_kws); change()"
                on-tag-removed="storyObj.taxonomy.seo_keywords = tagsToArray(seo_kws); change()"
                on-tag-added="storyObj.taxonomy.seo_keywords = tagsToArray(seo_kws); change()"
                placeholder="${intl.get(
                  'MetaTemplates.seo.template.seoPlaceholder'
                )}"
                data-desc="SEO Keywords"
                replace-spaces-with-dashes="false"
                el-sortable>
              </tags-input>
            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.seo.description'),
      isValid: (storyObj) => {
        return (
          storyObj.taxonomy &&
          storyObj.taxonomy.seo_keywords &&
          storyObj.taxonomy.seo_keywords.length
        )
      },
    }

    baseMetaTemplates.stock_symbols = {
      label: intl.get('MetaTemplates.stockSymbols.label'),
      template: `<div class="form-group">
              <label for="tax_stock">${intl.get(
                'MetaTemplates.stockSymbols.template.stockSymbolsLabel'
              )} ${isRequired}</label>
              <tags-input
                data-testid="editor-stock-symbols-input"
                min-length="1"
                ng-class="{'required': isRequiredNotify}"
                ng-model="stocks"
                ng-init="stocks=(storyObj.taxonomy.stock_symbols || []).slice()"
                ng-change="storyObj.taxonomy.stock_symbols=tagsToArray(stocks); change()"
                on-tag-removed="storyObj.taxonomy.stock_symbols=tagsToArray(stocks); change()"
                on-tag-added="storyObj.taxonomy.stock_symbols=tagsToArray(stocks); change()"
                placeholder="${intl.get(
                  'MetaTemplates.stockSymbols.template.stockSymbolsPlaceholder'
                )}"
                data-desc="Stock Symbols"
                el-sortable>
              </tags-input>
            </div>
            <snowball-suggests
              ng-show="companySettings.displaySnowball"
              story-obj="storyObj"
              ng-model="stocks"></snowball-suggests>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.stockSymbols.description'),
      isValid: (storyObj) => {
        return (
          storyObj.taxonomy &&
          storyObj.taxonomy.stock_symbols &&
          storyObj.taxonomy.stock_symbolslength
        )
      },
    }

    baseMetaTemplates.syndication = {
      label: intl.get('MetaTemplates.syndication.label'),
      template: `<div class="form-group">
            <h5>${intl.get(
              'MetaTemplates.syndication.template.syndicationTitle'
            )} ${isRequired}</h5>
              <div class="form-group">
                <select multiple size="3" class="form-control" ng-model="syndicationOpts" ng-change="syndicationChange()">
                  <option data-testid="editor-syndication-none-btn" value="">
                  ${intl.get('MetaTemplates.syndication.template.optionNone')}
                  </option>
                  <option data-testid="editor-syndication-external-btn" value="external_distribution">
                  ${intl.get(
                    'MetaTemplates.syndication.template.optionExternalDistribution'
                  )}
                  </option>
                  <option data-testid="editor-syndication-visible-btn" value="search">
                  ${intl.get('MetaTemplates.syndication.template.optionSearch')}
                  </option>
                </select>
              </div>
            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: '',
      isValid: (storyObj) => {
        return !!storyObj.syndication
      },
    }

    // in 0.5.8 correction is like
    // {
    //   type: <string enum> ['correction']
    //   text: <string>
    // }
    // there is only one enum, so just dont even hook it up to a model
    baseMetaTemplates.corrections = {
      label: intl.get('MetaTemplates.corrections.label'),
      template: `<div class="form-group">
               <h5>${intl.get(
                 'MetaTemplates.corrections.label'
               )} ${isRequired}</h5>
                <div class="row" ng-repeat="correction in storyObj.corrections track by $index">
                  <div class="form-group col-md-3">
                    <label for="correction_type{{$index}}">${intl.get(
                      'MetaTemplates.corrections.template.type'
                    )}</label>
                    <select
                      data-testid="editor-corrections-type-btn"
                      ng-change="change()"
                      ng-class="{'required': isRequiredNotify}"
                      class="form-control"
                      ng-model="correction.correction_type"
                      ng-options="key as value for (key, value) in {
                        correction: '${intl.get(
                          'MetaTemplates.corrections.template.correction'
                        )}',
                        clarification: '${intl.get(
                          'MetaTemplates.corrections.template.clarification'
                        )}'
                      }">
                    </select>
                  </div>
                  <div class="form-group col-md-8">
                    <label for="correction_text{{$index}}">${intl.get(
                      'MetaTemplates.corrections.template.text'
                    )}</label>
                    <input type="text"
                      ng-class="{'required': isRequiredNotify}"
                      class="form-control"
                      id="correction_text{{$index}}"
                      placeholder="${intl.get(
                        'MetaTemplates.corrections.template.placeholder'
                      )}"
                      ng-change="change()"
                      ng-model="correction.text">
                  </div>
                  <div class="form-group col-md-1">
                    <label>&nbsp;&nbsp;&nbsp;</label>
                    <button
                      data-testid="editor-remove-correction-btn"
                      class="btn btn-secondary form-control"
                      ng-click="removeIndex(storyObj.corrections, $index)"
                      title="Remove correction"
                      type="button">
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <button
                  data-testid="editor-add-correction-btn"
                  class="btn btn-outline-primary"
                  type="button"
                  ng-click="addCorrection()">${intl.get(
                    'MetaTemplates.corrections.template.addNew'
                  )}</button>
            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: 'A way to make note changes to the story.',
      isValid: (storyObj) => {
        return storyObj.corrections && storyObj.corrections.length
      },
    }

    baseMetaTemplates.sponsored_content = {
      label: intl.get('MetaTemplates.sponsoredContent.label'),
      template: `<div>
            <h5>${intl.get(
              'MetaTemplates.sponsoredContent.template.sponsoredContentTitle'
            )} ${isRequired}</h5>
            <div class="form-group meta-boolean">
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input
                    data-testid="editor-sponsored-content-yes-input"
                    ng-class="{'required': isRequiredNotify}"
                    type="radio"
                    name="sponsor"
                    class="form-check-input"
                    ng-change="change()"
                    ng-value="true"
                    value="true"
                    ng-model="storyObj.owner.sponsored" />
                    ${intl.get(
                      'MetaTemplates.sponsoredContent.template.optionYes'
                    )}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input
                    data-testid="editor-sponsored-content-no-input"
                    ng-class="{'required': isRequiredNotify}"
                    type="radio"
                    name="sponsor"
                    class="form-check-input"
                    ng-change="change()"
                    ng-value="false"
                    value="false"
                    ng-model="storyObj.owner.sponsored" />
                    ${intl.get(
                      'MetaTemplates.sponsoredContent.template.optionNo'
                    )}
                </label>
              </div>
            </div>

            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.sponsoredContent.description'),
      isValid: (storyObj) => {
        return storyObj.owner && storyObj.owner.sponsored !== undefined
      },
    }

    baseMetaTemplates.comments = {
      label: intl.get('MetaTemplates.comments.label'),
      template: `<div class="meta-boolean">
            <h5>${intl.get(
              'MetaTemplates.comments.template.commentsTitle'
            )} ${isRequired}</h5>
            <!-- EL-12 hide period
            <div class="form-group">
              <label>${intl.get(
                'MetaTemplates.comments.template.commentsPeriodLabel'
              )}</label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  placeholder=""
                  ng-change="change()"
                  ng-model="storyObj.comments.comments_period">
            </div>-->

            <div class="form-group">
              <div class="form-check form-check-inline">
                <label>${intl.get(
                  'MetaTemplates.comments.template.allowCommentsLabel'
                )}</label>
                <label class="form-check-label">
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="radio"
                    class="form-check-input"
                    ng-change="change()"
                    ng-model="storyObj.comments.allow_comments"
                    ng-value="true">
                    ${intl.get('MetaTemplates.comments.template.optionYes')}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input
                    ng-class="{'required': isRequiredNotify}"
                    type="radio"
                    class="form-check-input"
                    ng-change="change()"
                    ng-model="storyObj.comments.allow_comments"
                    ng-value="false">
                    ${intl.get('MetaTemplates.comments.template.optionNo')}
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check form-check-inline">
                <label>${intl.get(
                  'MetaTemplates.comments.template.displayCommentsLabel'
                )}</label>
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    ng-change="change()"
                    ng-model="storyObj.comments.display_comments"
                    ng-value="true">
                    ${intl.get('MetaTemplates.comments.template.optionYes')}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    ng-change="change()"
                    ng-model="storyObj.comments.display_comments"
                    ng-value="false">
                    ${intl.get('MetaTemplates.comments.template.optionNo')}
                </label>
              </div>
            </div>


            <div class="form-group" ng-show="canModerateComments()">
              <div class="form-check form-check-inline">
                <label>${intl.get(
                  'MetaTemplates.comments.template.moderationRequiredLabel'
                )}</label>
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    ng-change="change()"
                    ng-model="storyObj.comments.moderation_required"
                    ng-value="true">
                    ${intl.get('MetaTemplates.comments.template.optionYes')}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    ng-change="change()"
                    ng-model="storyObj.comments.moderation_required"
                    ng-value="false">
                    ${intl.get('MetaTemplates.comments.template.optionNo')}
                </label>
              </div>
            </div>


            </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.comments.description'),
      isValid: (storyObj) => {
        return (
          storyObj.comments &&
          storyObj.comments.allow_comments !== undefined &&
          storyObj.comments.display_comments !== undefined
        )
      },
    }

    // `<site-selection
    //       is-required="isRequired"
    //       is-required-notify="isRequiredNotify"
    //       sites-obj="sitesObj"
    //       story-obj="storyObj">
    //     </site-selection>`,
    baseMetaTemplates.section = {
      label: intl.get('MetaTemplates.section.label'),
      template: `
        <website-selection
          is-required="isRequired"
          is-required-notify="isRequiredNotify"
          websites-obj="websitesObj"
          story-obj="storyObj"
          company-settings="companySettings">
        </website-selection>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.section.description'),
      isValid: (storyObj) => {
        return (
          storyObj.taxonomy &&
          storyObj.taxonomy.sections &&
          storyObj.taxonomy.sections.length
        )
      },
    }

    // todo: daniel: why is this not taking controller as?
    baseMetaTemplates.author_selection = {
      template: `
            <author-selection
              is-required-notify="isRequiredNotify"
              is-required="isRequired"
              story-obj="storyObj"
              company-settings="companySettings"
              ng-model="storyObj.credits.by">
              ${intl.get('MetaTemplates.authorSelection.template.authorTitle')}
            </author-selection>`,
      label: intl.get('MetaTemplates.authorSelection.label'),
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.authorSelection.description'),
      isValid: (storyObj) => {
        return (
          storyObj.credits && storyObj.credits.by && storyObj.credits.by.length
        )
      },
    }

    baseMetaTemplates.schedule_planning = {
      label: intl.get('MetaTemplates.schedulePlanning.label'),
      template: `<div class="row">
                        <div class="form-group col-md-6">
                          <label for="planned-ready-time">${intl.get(
                            'MetaTemplates.schedulePlanning.label'
                          )} ${isRequired}</label>
                          <calendar-control
                            time="storyObj.planning.scheduling.planned_publish_date"
                            label="${intl.get(
                              'MetaTemplates.schedulePlanning.label'
                            )}"
                            disable-clear="false"
                            limit-date="plannedDateLimit"
                            default-timezone="orgTimezone"
                            timezone-text="${intl.get(
                              'MetaTemplates.schedulePlanning.timezoneLabel'
                            )}"
                            update="updatePlannedDate(time)"
                            displayTime=""
                          ></calendar-control>
                          <quick-time-picker
                            class="form-group"
                            ns-key="pp"
                            ng-model="storyObj.planning.scheduling.planned_publish_date"
                          >
                          </quick-time-picker>
                        </div>
                      </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.schedulePlanning.description'),
      isValid: (storyObj) => {
        return (
          storyObj.planning &&
          storyObj.planning.scheduling &&
          storyObj.planning.scheduling.planned_publish_date &&
          storyObj.planning.scheduling.planned_publish_date.toString().length
        )
      },
    }

    baseMetaTemplates.media_planning = {
      label: intl.get('MetaTemplates.mediaPlanning.label'),
      template: `<fieldset class="form-group row meta-boolean">
                    <legend class="col-form-legend col">${intl.get(
                      'MetaTemplates.mediaPlanning.template.legend'
                    )} ${isRequired}:</legend>
                    <div class="col">
                      <div class="form-check-inline">
                        <label data-testid="editor-will-have-photo-btn" class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="chk_photos"
                            ng-change="change()"
                            ng-model="storyObj.planning.scheduling.will_have_image"
                            ng-checked="storyObj.planning.scheduling.will_have_image" />
                            ${intl.get(
                              'MetaTemplates.mediaPlanning.template.checkPhoto'
                            )}
                          </label>
                      </div>
                      <div class="form-check-inline">
                        <label data-testid="editor-will-have-gallery-btn" class="form-check-label">
                          <input
                            ng-class="{'required': isRequiredNotify}"
                            type="checkbox"
                            class="form-check-input"
                            id="chk_gallery"
                            ng-change="change()"
                            ng-model="storyObj.planning.scheduling.will_have_gallery"
                            ng-checked="storyObj.planning.scheduling.will_have_gallery" />
                            ${intl.get(
                              'MetaTemplates.mediaPlanning.template.checkGallery'
                            )}
                          </label>
                      </div>
                      <div class="form-check-inline">
                        <label data-testid="editor-will-have-video-btn" class="form-check-label">
                          <input
                            ng-class="{'required': isRequiredNotify}"
                            type="checkbox"
                            class="form-check-input"
                            id="chk_videos"
                            ng-change="change()"
                            ng-model="storyObj.planning.scheduling.will_have_video"
                            ng-checked="storyObj.planning.scheduling.will_have_video" />
                            ${intl.get(
                              'MetaTemplates.mediaPlanning.template.checkVideo'
                            )}
                          </label>
                      </div>
                      <div class="form-check-inline">
                        <label data-testid="editor-will-have-graphic-btn" class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="chk_graphics"
                            ng-change="change()"
                            ng-model="storyObj.planning.scheduling.will_have_graphic"
                            ng-checked="storyObj.planning.scheduling.will_have_graphic" />
                            ${intl.get(
                              'MetaTemplates.mediaPlanning.template.checkGraphic'
                            )}
                          </label>
                      </div>
                    </div>
                  </fieldset>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.mediaPlanning.description'),
      isValid: (storyObj) => {
        return (
          storyObj.planning &&
          (storyObj.planning.scheduling.will_have_image ||
            storyObj.planning.scheduling.will_have_gallery ||
            storyObj.planning.scheduling.will_have_video ||
            storyObj.planning.scheduling.will_have_graphic)
        )
      },
    }

    baseMetaTemplates.planned_word_count = {
      label: intl.get('MetaTemplates.plannedWordCount.label'),
      template: `<div class="row">
                   <div class="form-group col-md-4">
                     <label for="word-count">${intl.get(
                       'MetaTemplates.plannedWordCount.template.plannedWordCountLabel'
                     )} ${isRequired}</label>
                     <input
                       ng-class="{'required': isRequiredNotify}"
                       id="word-count"
                       type="number"
                       class="form-control"
                       ng-change="change()"
                       ng-model="storyObj.planning.story_length.word_count_planned"
                       onchange='this.value=Math.ceil(this.value)'
                       placeholder="${intl.get(
                         'MetaTemplates.plannedWordCount.template.plannedWordCountPlaceholder'
                       )}"
                       step="1"
                       min="0" />
                   </div>
                </div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.plannedWordCount.description'),
      isValid: (storyObj) => {
        return (
          storyObj.planning &&
          storyObj.planning.story_length &&
          storyObj.planning.story_length.word_count_planned
        )
      },
    }

    baseMetaTemplates.planned_line_count = {
      label: intl.get('MetaTemplates.plannedLineCount.label'),
      template: `<div class="row"><div class="form-group col-md-4">
                   <label for="line-count">${intl.get(
                     'MetaTemplates.plannedLineCount.template.plannedLineCountLabel'
                   )} ${isRequired}</label>
                   <input
                     ng-class="{'required': isRequiredNotify}"
                     id="line-count"
                     type="number"
                     class="form-control"
                     ng-model="storyObj.planning.story_length.line_count_planned"
                     ng-change="change()"
                     onchange='this.value=Math.ceil(this.value)'
                     placeholder="${intl.get(
                       'MetaTemplates.plannedLineCount.template.plannedLineCountPlaceholder'
                     )}"
                     step="1"
                     min="0" />
                 </div></div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.plannedLineCount.description'),
      isValid: (storyObj) => {
        return !!get(storyObj, 'planning.story_length.line_count_planned')
      },
    }

    baseMetaTemplates.planned_inch_count = {
      label: intl.get('MetaTemplates.plannedInchCount.label'),
      template: `<div class="row"><div class="form-group col-md-4">
                   <label for="inch-count">${intl.get(
                     'MetaTemplates.plannedInchCount.template.plannedInchCountLabel'
                   )} ${isRequired}</label>
                   <input
                     ng-class="{'required': isRequiredNotify}"
                     id="inch-count"
                     type="number"
                     class="form-control"
                     ng-model="storyObj.planning.story_length.inch_count_planned"
                     ng-change="change()"
                     onchange='this.value=Math.ceil(this.value)'
                     placeholder="${intl.get(
                       'MetaTemplates.plannedInchCount.template.plannedInchCountPlaceholder'
                     )}"
                     step="1"
                     min="0" />
                 </div></div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.plannedInchCount.description'),
      isValid: (storyObj) => {
        return (
          storyObj.planning &&
          storyObj.planning.story_length &&
          storyObj.planning.story_length.inch_count_planned
        )
      },
    }

    baseMetaTemplates.planned_character_count = {
      label: intl.get('MetaTemplates.plannedCharacterCount.label'),
      template: `<div class="row"><div class="form-group col-md-4">
                   <label for="inch-count">${intl.get(
                     'MetaTemplates.plannedCharacterCount.template.plannedCharacterCountLabel'
                   )} ${isRequired}</label>
                   <input
                     ng-class="{'required': isRequiredNotify}"
                     id="character-count"
                     type="number"
                     class="form-control"
                     ng-model="storyObj.planning.story_length.character_count_planned"
                     ng-change="change()"
                     onchange='this.value=Math.ceil(this.value)'
                     placeholder="${intl.get(
                       'MetaTemplates.plannedCharacterCount.template.plannedCharacterCountPlaceholder'
                     )}"
                     step="1"
                     min="0" />
                 </div></div>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'planning',
      description: intl.get('MetaTemplates.plannedInchCount.description'),
      isValid: (storyObj) => {
        return (
          storyObj.planning &&
          storyObj.planning.story_length &&
          storyObj.planning.story_length.character_count_planned
        )
      },
    }

    baseMetaTemplates.story_tags = {
      label: intl.get('MetaTemplates.storyTags.label'),
      template: `
            <story-tags
              story-obj="storyObj"
              is-required-notify="isRequiredNotify"
              is-required="isRequired">
            </story-tags>
          `,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.storyTags.description'),
      isValid: (storyObj) => {
        return (
          storyObj.taxonomy &&
          storyObj.taxonomy.tags &&
          storyObj.taxonomy.tags.length
        )
      },
    }

    baseMetaTemplates.label = {
      label: intl.get('MetaTemplates.label.label'),
      template: `<kicker story-obj="storyObj"></kicker>`,
      tab: 'meta',
      description: intl.get('MetaTemplates.label.description'),
      isValid: (storyObj) => {
        return (
          storyObj.label &&
          Object.keys(storyObj.label).some((labelKey) => {
            return storyObj.label[labelKey].text
          })
        )
      },
    }

    baseMetaTemplates.redirect = {
      label: intl.get('MetaTemplates.redirect.label'),
      template: `<div class="form-group">
          <h5>${intl.get(
            'MetaTemplates.redirect.template.redirectLabel'
          )} ${isRequired}
            <i class="fa fa-info-circle" data-toggle="tooltip" data-placement="right" title="${intl.get(
              'MetaTemplates.redirect.template.redirectTooltip'
            )}"></i>
          </h5>

          <div class="row">
            <div class="form-group col-md-8">
              <label>
              ${intl.get('MetaTemplates.redirect.template.forwardUrlLabel')}
                <i class="fa fa-info-circle" data-toggle="tooltip" data-placement="right" title="${intl.get(
                  'MetaTemplates.redirect.template.forwardUrlTooltip'
                )}"></i>
              </label>
              <input type="text"
                ng-class="{'required': isRequiredNotify}"
                class="form-control"
                ng-change="change()"
                placeholder="${intl.get(
                  'MetaTemplates.redirect.template.forwardUrlPlaceholder'
                )}"
                ng-model="storyObj.redirect.forwardUrl"
                ng-disabled="!storyObj.additional_properties.is_published" />
            </div>
          </div>
        </div>`,
      tab: 'planning',
      description: intl.get('MetaTemplates.redirect.description'),
    }

    baseMetaTemplates.canonical_url = {
      type: 'String',
      label: intl.get('MetaTemplates.canonicalUrl.label'),
      isReadOnly: '{{is_published}}',
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.canonicalUrl.description'),
      template: `<canonical-url story-obj="storyObj"></canonical-url>`,
    }

    baseMetaTemplates.distributor = {
      label: intl.get('MetaTemplates.distributor.label'),
      template: `
        <distributor
          is-required="isRequired"
          is-required-notify="isRequiredNotify"
          story-obj="storyObj">
        </distributor>`,
      properties: {},
      picklist: false,
      default: true,
      tab: 'meta',
      description: intl.get('MetaTemplates.distributor.description'),
      hideIfDisabled: true,
      isIncomplete: (storyObj) => {
        return (
          get(storyObj, 'distributor.mode') === 'custom' &&
          (!storyObj.distributor.name || !storyObj.distributor.category)
        )
      },
      isValid: (storyObj) => {
        return (
          !!storyObj.distributor &&
          (storyObj.distributor.mode === 'reference' ||
            (!!storyObj.distributor.name && !!storyObj.distributor.category))
        )
      },
    }

    baseMetaTemplates.publish_date = {
      label: intl.get('BasicTemplateConfig.publishDate.label'),
      template: `
        <publish-date
          is-required="isRequired"
          is-required-notify="isRequiredNotify"
          story-obj="storyObj">
        </publish-date>`,
      properties: {},
      picklist: false,
      default: true,
      isReadOnly: true,
      isTextOnly: true,
      tab: 'meta',
      description: intl.get('BasicTemplateConfig.publishDate.description'),
      hideIfDisabled: false,
    }

    baseMetaTemplates.canonical_website = {
      label: intl.get('circulation.tab.primaryWebsiteLabel'),
      template: '<primary-website-field />',
      isValid: (storyObj) =>
        storyObj.canonical_website && storyObj.canonical_website.length,
    }

    $ngRedux.dispatch(setFieldConfigs(baseMetaTemplates))

    return baseMetaTemplates
  }

  renderPicklists({})
  picklistService.afterPicklistSet(function (event) {
    renderPicklists(event['payload'])
  })

  this.getMetaItems = () => baseMetaTemplates

  this.hasTemplate = (key) => baseMetaTemplates.hasOwnProperty(key)

  this.getTemplate = function (type) {
    return (baseMetaTemplates[type] || baseMetaTemplates.unknown(type)).template
  }

  this.getMetaItem = (type) => baseMetaTemplates[type]

  this.isMetaItemValid = (templateId, storyObj) => {
    var templateObj =
      baseMetaTemplates[templateId] || baseMetaTemplates.unknown(templateId)
    return { isValid: templateObj.isValid(storyObj), details: templateObj }
  }

  this.beforeSaveMethod = (storyObj) => {
    Object.keys(baseMetaTemplates).forEach((key) => {
      if (baseMetaTemplates[key].beforeOnSave) {
        baseMetaTemplates[key].beforeOnSave(storyObj)
      }
    })
  }

  this.requiredForSave = (settings, storyObj) => {
    settings = {
      ...settings,
      extra: [
        {
          key: 'canonical_website',
          settings: {
            requiredSave: true,
          },
        },
      ],
    }
    return handleRequired('requiredSave', settings, storyObj, baseMetaTemplates)
  }

  this.requiredForPublish = (settings, storyObj) => {
    return handleRequired(
      'requiredPublish',
      settings,
      storyObj,
      baseMetaTemplates
    )
  }
}
